// @ts-nocheck
import { ScrollContext } from "@store/Framework/ContextApi/ScrollContextProvider";
import { useContext } from "react";

export default () => useContext(ScrollContext);
